export const isDevEnvironment = () => import.meta.env.REACT_APP_ENV === "dev";
